// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6317":"7c7b8d26","6588":"46c3ec30","7984":"7bbbe33b"}[chunkId] + ".chunk.css";
};